import { getApiClient as I, useTenant as D, requireTenantId as F, buildSearchWhere as xe, SystemBadge as Te, SearchInput as Ne, ConfirmDialog as Pe, LoadingSpinner as ie, ApiErrorDisplay as re, EmptyState as Se, useColorScheme as Ce, TemplateVariablesTable as Fe, HtmlPreviewDialog as Ie } from "@authifi/clique-react-ui";
import { useQueryClient as G, useMutation as A, useQuery as J, keepPreviousData as qe } from "@tanstack/react-query";
import { jsx as l, jsxs as c } from "react/jsx-runtime";
import { useState as h, useMemo as U, useCallback as b, useEffect as W, useRef as Y } from "react";
import { DataTable as De } from "primereact/datatable";
import { Column as k } from "primereact/column";
import { Button as C } from "primereact/button";
import { Dialog as Le } from "primereact/dialog";
import { InputText as z } from "primereact/inputtext";
import { Chips as te } from "primereact/chips";
import { Panel as je } from "primereact/panel";
import { Toast as le } from "primereact/toast";
import Oe from "@monaco-editor/react";
import { Dropdown as Me } from "primereact/dropdown";
const se = "access-request-group-invitation.hbs";
function q(a) {
  return `/auth/admin/tenants/${a}`;
}
const L = {
  list(a, t) {
    return I().get(`${q(a)}/email-templates`, {
      params: t ? { filter: JSON.stringify(t) } : void 0
    });
  },
  getById(a, t) {
    return I().get(`${q(a)}/email-template/${t}`);
  },
  create(a, t) {
    return I().post(`${q(a)}/email-template`, t);
  },
  update(a, t, r) {
    return I().put(`${q(a)}/email-template/${t}`, r);
  },
  // Note: `delete` intentionally uses the plural `email-templates/{id}` path
  // while `getById`/`update` use the singular `email-template/{id}`. This
  // mirrors the LabShare Auth backend routes exactly — do not "normalize" it.
  delete(a, t) {
    return I().delete(`${q(a)}/email-templates/${t}`);
  },
  getVariables(a, t) {
    return I().get(
      `${q(a)}/email-template-variables/${t}`
    );
  },
  compilePreview(a, t) {
    return I().post(
      `${q(a)}/email-template/compile-preview`,
      { messageTemplate: t }
    );
  },
  getCompiled(a, t) {
    return I().get(
      `${q(a)}/email-template/${t}/compiled`
    );
  }
}, S = {
  all: (a) => ["emailTemplates", a],
  list: (a, t) => [...S.all(a), "list", t],
  detail: (a, t) => [...S.all(a), "detail", t],
  variables: (a, t) => [...S.all(a), "variables", t]
};
function ne(a, t) {
  const { numericTenantId: r } = D(), n = a || t ? {
    ...t,
    where: { ...t == null ? void 0 : t.where, ...a ? { categoryLabel: a } : {} }
  } : void 0;
  return J({
    queryKey: S.list(r, n),
    queryFn: () => L.list(F(r), n).then((s) => s.data),
    enabled: r !== null,
    placeholderData: qe
  });
}
function Re(a) {
  const { numericTenantId: t } = D();
  return J({
    queryKey: S.detail(t, a),
    queryFn: () => L.getById(F(t), a).then((r) => r.data),
    enabled: t !== null && a > 0
  });
}
function $e(a) {
  const { numericTenantId: t } = D();
  return J({
    queryKey: S.variables(t, a),
    queryFn: () => L.getVariables(F(t), a).then((r) => r.data),
    enabled: t !== null && a.length > 0
  });
}
function ke() {
  const { numericTenantId: a } = D(), t = G();
  return A({
    onMutate: () => ({ tenantId: F(a) }),
    mutationFn: (r) => {
      const n = F(a);
      return L.create(n, { ...r, tenantId: n, isSystemTemplate: !1 }).then((s) => s.data);
    },
    onSuccess: (r, n, s) => {
      t.invalidateQueries({ queryKey: S.all(s.tenantId) });
    }
  });
}
function Ae() {
  const { numericTenantId: a } = D(), t = G();
  return A({
    onMutate: () => ({ tenantId: F(a) }),
    mutationFn: ({
      id: r,
      data: n
    }) => {
      const s = F(a);
      return L.update(s, r, { ...n, id: r, tenantId: s, isSystemTemplate: !1 }).then((i) => i.data);
    },
    onSuccess: (r, { id: n }, s) => {
      t.invalidateQueries({ queryKey: S.all(s.tenantId) }), t.invalidateQueries({ queryKey: S.detail(s.tenantId, n) });
    }
  });
}
function He() {
  const { numericTenantId: a } = D(), t = G();
  return A({
    onMutate: () => ({ tenantId: F(a) }),
    mutationFn: (r) => {
      const n = F(a);
      return L.delete(n, r);
    },
    onSuccess: (r, n, s) => {
      t.invalidateQueries({ queryKey: S.all(s.tenantId) });
    }
  });
}
function oe(a) {
  if (typeof a == "object" && a !== null && "response" in a)
    return a;
}
function de(a) {
  var t, r;
  return (r = (t = oe(a)) == null ? void 0 : t.response) == null ? void 0 : r.status;
}
function ze(a) {
  var r, n;
  const t = (n = (r = oe(a)) == null ? void 0 : r.response) == null ? void 0 : n.data;
  if (typeof t == "object" && t !== null && "error" in t) {
    const s = t.error;
    if (typeof s == "object" && s !== null && "message" in s) {
      const i = s.message;
      if (typeof i == "string") return i;
    }
  }
}
function Ke(a) {
  const { categoryLabel: t, onSuccess: r, onError: n } = a ?? {}, [s, i] = h(""), [d, e] = h(null), y = U(() => {
    const v = xe(["name"], s);
    return v ? { where: v } : void 0;
  }, [s]), {
    data: o,
    isLoading: w,
    isError: m,
    error: u,
    refetch: x
  } = ne(t, y), T = He(), j = b(() => {
    d && T.mutate(d.id, {
      onSuccess: () => {
        r == null || r(`Template "${d.name}" deleted successfully.`), e(null);
      },
      onError: (v) => {
        console.error("Failed to delete email template", v);
        const M = de(v), P = ze(v);
        M === 403 && P && /in use/i.test(P) ? n == null || n("This template is in use by a group invitation and cannot be deleted.") : n == null || n("Failed to delete template. Please try again."), e(null);
      }
    });
  }, [d, T, r, n]), N = (o == null ? void 0 : o.length) === 0 && !s, O = (o == null ? void 0 : o.length) === 0 && !!s;
  return {
    templates: o,
    search: s,
    setSearch: i,
    isLoading: w,
    isError: m,
    error: u,
    refetch: () => void x(),
    isEmpty: N,
    isEmptySearch: O,
    deleteTarget: d,
    setDeleteTarget: e,
    handleDelete: j,
    isDeleting: T.isPending,
    filter: y
  };
}
function ot({
  categoryLabel: a,
  onTemplateSelect: t,
  onCreateTemplate: r,
  onSuccess: n,
  onError: s
}) {
  var m;
  const i = Ke({ categoryLabel: a, onSuccess: n, onError: s }), d = b(
    (u) => /* @__PURE__ */ l(Te, { isSystem: u.isSystemTemplate }),
    []
  ), e = b(
    (u) => /* @__PURE__ */ l("span", { className: "text-[var(--clique-fg-secondary)]", children: u.messageSubject || "—" }),
    []
  ), y = b(
    (u) => /* @__PURE__ */ l("span", { className: "text-[var(--clique-fg-secondary)] text-sm", children: new Date(u.updatedAt).toLocaleDateString() }),
    []
  ), o = b(
    (u) => /* @__PURE__ */ c("div", { className: "flex gap-1", children: [
      /* @__PURE__ */ l(
        C,
        {
          type: "button",
          icon: "pi pi-pencil",
          severity: "secondary",
          text: !0,
          size: "small",
          tooltip: "Edit",
          tooltipOptions: { position: "top" },
          onClick: (x) => {
            x.stopPropagation(), t == null || t(u);
          }
        }
      ),
      !u.isSystemTemplate && /* @__PURE__ */ l(
        C,
        {
          type: "button",
          icon: "pi pi-trash",
          severity: "danger",
          text: !0,
          size: "small",
          tooltip: "Delete",
          tooltipOptions: { position: "top" },
          onClick: (x) => {
            x.stopPropagation(), i.setDeleteTarget(u);
          }
        }
      )
    ] }),
    [t, i]
  ), w = () => i.isLoading && !i.templates ? /* @__PURE__ */ l(ie, { message: "Loading templates..." }) : i.isError ? /* @__PURE__ */ l(
    re,
    {
      error: i.error,
      resourceLabel: "email templates",
      onRetry: i.refetch
    }
  ) : i.isEmpty ? /* @__PURE__ */ l(
    Se,
    {
      icon: "pi pi-envelope",
      title: "No email templates yet",
      message: "Create an email template to customize invitation emails.",
      actionLabel: r ? "Create Template" : void 0,
      onAction: r
    }
  ) : /* @__PURE__ */ c(
    De,
    {
      value: i.templates ?? [],
      loading: i.isLoading,
      dataKey: "id",
      emptyMessage: "No templates match your search.",
      selectionMode: "single",
      onSelectionChange: (u) => {
        u.value && (t == null || t(u.value));
      },
      rowHover: !0,
      stripedRows: !0,
      className: "rounded-lg border border-[var(--clique-border)] overflow-hidden",
      rowClassName: () => t ? "cursor-pointer" : "",
      children: [
        /* @__PURE__ */ l(k, { field: "name", header: "Name", sortable: !0, className: "font-medium" }),
        /* @__PURE__ */ l(k, { header: "Subject", body: e }),
        /* @__PURE__ */ l(k, { header: "Type", body: d, style: { width: "120px" } }),
        /* @__PURE__ */ l(k, { header: "Updated", body: y, style: { width: "120px" } }),
        /* @__PURE__ */ l(k, { header: "Actions", body: o, style: { width: "120px" } })
      ]
    }
  );
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ c("div", { className: "flex items-center justify-between mb-4 gap-4", children: [
      /* @__PURE__ */ l(
        Ne,
        {
          value: i.search,
          onChange: i.setSearch,
          placeholder: "Search templates by name...",
          className: "flex-1 max-w-md"
        }
      ),
      r && /* @__PURE__ */ l(C, { label: "New Template", icon: "pi pi-plus", onClick: r, size: "small" })
    ] }),
    w(),
    /* @__PURE__ */ l(
      Pe,
      {
        visible: i.deleteTarget !== null,
        onHide: () => i.setDeleteTarget(null),
        onConfirm: i.handleDelete,
        header: "Delete Template",
        message: `Are you sure you want to delete "${(m = i.deleteTarget) == null ? void 0 : m.name}"? This action cannot be undone.`,
        confirmLabel: "Delete",
        confirmIcon: "pi pi-trash",
        confirmSeverity: "danger",
        loading: i.isDeleting
      }
    )
  ] });
}
function Be({
  value: a,
  onChange: t,
  readOnly: r = !1,
  height: n = "300px"
}) {
  const s = Ce() === "dark", i = b(
    (d) => {
      t == null || t(d ?? "");
    },
    [t]
  );
  return /* @__PURE__ */ l("div", { className: "border border-[var(--clique-border)] rounded-lg overflow-hidden", children: /* @__PURE__ */ l(
    Oe,
    {
      height: n,
      defaultLanguage: "html",
      value: a,
      onChange: i,
      theme: s ? "vs-dark" : "light",
      options: {
        readOnly: r,
        minimap: { enabled: !1 },
        wordWrap: "on",
        scrollBeyondLastLine: !1,
        lineNumbers: "on",
        fontSize: 13,
        tabSize: 2,
        automaticLayout: !0
      }
    }
  ) });
}
function _e({ categoryLabel: a }) {
  const {
    data: t,
    isLoading: r,
    isError: n,
    error: s,
    refetch: i
  } = $e(a);
  return /* @__PURE__ */ l(
    Fe,
    {
      variables: t,
      isLoading: r,
      isError: n,
      error: s,
      onRetry: () => void i()
    }
  );
}
function me({
  visible: a,
  onHide: t,
  html: r
}) {
  return /* @__PURE__ */ l(
    Ie,
    {
      visible: a,
      onHide: t,
      header: "Email Preview",
      srcDoc: r,
      width: "60rem",
      height: "85vh"
    }
  );
}
const ae = {
  name: "",
  messageSubject: "",
  messageFrom: "",
  description: "",
  cc: [],
  bcc: [],
  messageTemplate: ""
};
function Ve(a) {
  const {
    visible: t,
    templateId: r,
    categoryLabel: n = se,
    onSaved: s,
    onHide: i,
    onPreviewError: d
  } = a, e = r != null && r > 0, { numericTenantId: y } = D(), [o, w] = h(ae), [m, u] = h(""), [x, T] = h(""), [j, N] = h(""), [O, v] = h(""), [M, P] = h(""), [R, $] = h(!1), [K, g] = h(!1), [B, X] = h(""), {
    data: f,
    isLoading: ce,
    isError: ue,
    error: pe,
    refetch: ge
  } = Re(e ? r : 0), _ = ke(), V = Ae(), Q = A({
    mutationFn: (p) => {
      if (y === null)
        throw new Error("Tenant ID is not resolved yet.");
      return L.compilePreview(y, p).then((E) => E.data);
    }
  }), fe = _.isPending || V.isPending, Z = (f == null ? void 0 : f.isSystemTemplate) === !0, he = e && Z, H = e ? (f == null ? void 0 : f.categoryLabel) ?? n : n, ve = o.messageTemplate.trim().length > 0;
  W(() => {
    t && (e ? $(!1) : (w(ae), $(!0)), u(""), T(""), N(""), v(""), P(""), g(!1), X(""));
  }, [t, e]), W(() => {
    e && f && !R && (w({
      name: f.name,
      messageSubject: f.messageSubject ?? "",
      messageFrom: f.messageFrom ?? "",
      description: f.description ?? "",
      cc: f.cc ?? [],
      bcc: f.bcc ?? [],
      messageTemplate: f.messageTemplate ?? ""
    }), $(!0));
  }, [e, f, R]);
  const be = b(
    (p, E) => {
      w((Ee) => ({ ...Ee, [p]: E })), p === "name" && u(""), p === "messageSubject" && T(""), p === "messageFrom" && N(""), p === "messageTemplate" && v("");
    },
    []
  ), ee = b(() => {
    let p = !0;
    return o.name.trim() ? u("") : (u("Name is required."), p = !1), o.messageSubject.trim() ? T("") : (T("Subject is required."), p = !1), o.messageFrom.trim() ? N("") : (N("From address is required."), p = !1), o.messageTemplate.trim() ? v("") : (v("Email body is required."), p = !1), p;
  }, [o.name, o.messageSubject, o.messageFrom, o.messageTemplate]), ye = b(() => {
    o.messageTemplate.trim() && Q.mutate(o.messageTemplate, {
      onSuccess: (p) => {
        X(p.rawTemplate), g(!0);
      },
      onError: (p) => {
        console.error("Failed to compile email template preview", p), d == null || d("Failed to generate preview. Please try again.");
      }
    });
  }, [o.messageTemplate, Q, d]), we = b(() => {
    if (!ee()) return;
    P("");
    const p = {
      name: o.name.trim(),
      messageSubject: o.messageSubject.trim(),
      messageFrom: o.messageFrom.trim(),
      description: o.description.trim() || void 0,
      cc: o.cc.length > 0 ? o.cc : void 0,
      bcc: o.bcc.length > 0 ? o.bcc : void 0,
      messageTemplate: o.messageTemplate
    };
    e ? V.mutate(
      { id: r, data: { ...p, categoryLabel: H } },
      {
        onSuccess: (E) => {
          s == null || s(E), i == null || i();
        },
        onError: (E) => {
          console.error("Failed to update email template", E), P("Failed to update template. Please try again.");
        }
      }
    ) : _.mutate(
      { ...p, categoryLabel: H },
      {
        onSuccess: (E) => {
          s == null || s(E), i == null || i();
        },
        onError: (E) => {
          console.error("Failed to create email template", E), de(E) === 422 ? P("A template with this name already exists. Choose a different name.") : P("Failed to create template. Please try again.");
        }
      }
    );
  }, [
    o,
    ee,
    e,
    r,
    H,
    _,
    V,
    s,
    i
  ]);
  return {
    form: o,
    updateField: be,
    formInitialized: R,
    categoryLabel: H,
    isEditMode: e,
    isReadOnly: he,
    isSystemTemplate: Z,
    existingTemplate: f,
    isLoading: ce,
    isError: ue,
    fetchError: pe,
    refetch: () => void ge(),
    nameError: m,
    subjectError: x,
    fromError: j,
    templateError: O,
    submitError: M,
    handleSubmit: we,
    isPending: fe,
    canPreview: ve,
    showPreview: K,
    setShowPreview: g,
    previewHtml: B,
    handlePreview: ye,
    isPreviewPending: Q.isPending
  };
}
function Qe({
  visible: a,
  onHide: t,
  templateId: r,
  categoryLabel: n,
  onSaved: s
}) {
  const i = Y(null), d = Y(null), e = Ve({
    visible: a,
    templateId: r,
    categoryLabel: n,
    onSaved: s,
    onHide: t,
    onPreviewError: (m) => {
      var u;
      (u = d.current) == null || u.show({ severity: "error", summary: "Error", detail: m, life: 5e3 });
    }
  });
  W(() => {
    a && e.formInitialized && !e.isEditMode && setTimeout(() => {
      var m;
      return (m = i.current) == null ? void 0 : m.focus();
    }, 100);
  }, [a, e.formInitialized, e.isEditMode]);
  const y = () => {
    e.isPending || t();
  }, o = /* @__PURE__ */ c("div", { className: "flex items-center justify-between w-full", children: [
    /* @__PURE__ */ l("span", { children: e.isEditMode ? "Edit Email Template" : "New Email Template" }),
    e.canPreview && /* @__PURE__ */ l(
      C,
      {
        type: "button",
        label: "Preview",
        icon: "pi pi-eye",
        className: "p-button-text p-button-sm mr-4",
        onClick: e.handlePreview,
        loading: e.isPreviewPending,
        disabled: e.isPending
      }
    )
  ] }), w = !e.isEditMode || e.formInitialized && !e.isLoading && !e.isError;
  return /* @__PURE__ */ c(
    Le,
    {
      visible: a,
      onHide: y,
      header: o,
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !e.isPending,
      closeOnEscape: !e.isPending,
      maximizable: !0,
      style: { width: "64rem" },
      breakpoints: { "960px": "95vw" },
      footer: !e.isReadOnly && w ? /* @__PURE__ */ c("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ l(
          C,
          {
            type: "button",
            label: "Cancel",
            onClick: y,
            severity: "secondary",
            outlined: !0,
            disabled: e.isPending
          }
        ),
        /* @__PURE__ */ l(
          C,
          {
            type: "button",
            label: e.isEditMode ? "Save" : "Create",
            icon: "pi pi-check",
            onClick: e.handleSubmit,
            raised: !0,
            loading: e.isPending
          }
        )
      ] }) : void 0,
      children: [
        /* @__PURE__ */ l(le, { ref: d }),
        e.isEditMode && e.isLoading && /* @__PURE__ */ l(ie, { message: "Loading template..." }),
        e.isEditMode && e.isError && /* @__PURE__ */ l(
          re,
          {
            error: e.fetchError,
            resourceLabel: "template",
            onRetry: e.refetch
          }
        ),
        w && /* @__PURE__ */ c("div", { className: "flex flex-col gap-5", children: [
          e.isReadOnly && /* @__PURE__ */ c("div", { className: "bg-[var(--clique-warning-subtle)] border border-[var(--clique-warning-border)] rounded-lg p-3 text-sm text-[var(--clique-warning-strong)]", children: [
            /* @__PURE__ */ l("i", { "aria-hidden": "true", className: "pi pi-info-circle mr-2" }),
            "System Template - Read Only"
          ] }),
          /* @__PURE__ */ c("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-5", children: [
            /* @__PURE__ */ c("div", { className: "flex flex-col gap-1.5", children: [
              /* @__PURE__ */ c(
                "label",
                {
                  htmlFor: "email-template-name",
                  className: "text-sm font-semibold text-[var(--clique-fg)]",
                  children: [
                    "Name ",
                    /* @__PURE__ */ l("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                  ]
                }
              ),
              /* @__PURE__ */ l(
                z,
                {
                  id: "email-template-name",
                  ref: i,
                  value: e.form.name,
                  onChange: (m) => e.updateField("name", m.target.value),
                  placeholder: "e.g. Welcome invitation",
                  className: `w-full ${e.nameError ? "p-invalid" : ""}`,
                  "aria-invalid": !!e.nameError,
                  disabled: e.isReadOnly
                }
              ),
              e.nameError && /* @__PURE__ */ l("small", { className: "text-[var(--clique-destructive)] text-xs", children: e.nameError })
            ] }),
            /* @__PURE__ */ c("div", { className: "flex flex-col gap-1.5", children: [
              /* @__PURE__ */ c(
                "label",
                {
                  htmlFor: "email-template-from",
                  className: "text-sm font-semibold text-[var(--clique-fg)]",
                  children: [
                    "From ",
                    /* @__PURE__ */ l("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                  ]
                }
              ),
              /* @__PURE__ */ l(
                z,
                {
                  id: "email-template-from",
                  value: e.form.messageFrom,
                  onChange: (m) => e.updateField("messageFrom", m.target.value),
                  placeholder: "no-reply@example.com",
                  className: `w-full ${e.fromError ? "p-invalid" : ""}`,
                  "aria-invalid": !!e.fromError,
                  disabled: e.isReadOnly
                }
              ),
              e.fromError && /* @__PURE__ */ l("small", { className: "text-[var(--clique-destructive)] text-xs", children: e.fromError })
            ] })
          ] }),
          /* @__PURE__ */ c("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ c(
              "label",
              {
                htmlFor: "email-template-subject",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Subject ",
                  /* @__PURE__ */ l("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ l(
              z,
              {
                id: "email-template-subject",
                value: e.form.messageSubject,
                onChange: (m) => e.updateField("messageSubject", m.target.value),
                placeholder: "You're invited to join {{groupName}}",
                className: `w-full ${e.subjectError ? "p-invalid" : ""}`,
                "aria-invalid": !!e.subjectError,
                disabled: e.isReadOnly
              }
            ),
            e.subjectError && /* @__PURE__ */ l("small", { className: "text-[var(--clique-destructive)] text-xs", children: e.subjectError })
          ] }),
          /* @__PURE__ */ c("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ l(
              "label",
              {
                htmlFor: "email-template-description",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Description"
              }
            ),
            /* @__PURE__ */ l(
              z,
              {
                id: "email-template-description",
                value: e.form.description,
                onChange: (m) => e.updateField("description", m.target.value),
                placeholder: "Internal note describing this template",
                className: "w-full",
                disabled: e.isReadOnly
              }
            )
          ] }),
          /* @__PURE__ */ c("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-5", children: [
            /* @__PURE__ */ c("div", { className: "flex flex-col gap-1.5", children: [
              /* @__PURE__ */ l(
                "label",
                {
                  htmlFor: "email-template-cc",
                  className: "text-sm font-semibold text-[var(--clique-fg)]",
                  children: "CC"
                }
              ),
              /* @__PURE__ */ l(
                te,
                {
                  inputId: "email-template-cc",
                  value: e.form.cc,
                  onChange: (m) => e.updateField("cc", m.value ?? []),
                  placeholder: "Add an address and press Enter",
                  className: "w-full",
                  disabled: e.isReadOnly
                }
              )
            ] }),
            /* @__PURE__ */ c("div", { className: "flex flex-col gap-1.5", children: [
              /* @__PURE__ */ l(
                "label",
                {
                  htmlFor: "email-template-bcc",
                  className: "text-sm font-semibold text-[var(--clique-fg)]",
                  children: "BCC"
                }
              ),
              /* @__PURE__ */ l(
                te,
                {
                  inputId: "email-template-bcc",
                  value: e.form.bcc,
                  onChange: (m) => e.updateField("bcc", m.value ?? []),
                  placeholder: "Add an address and press Enter",
                  className: "w-full",
                  disabled: e.isReadOnly
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ c("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ c("label", { className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
              "Email Body (HTML) ",
              /* @__PURE__ */ l("span", { className: "text-[var(--clique-destructive)]", children: "*" })
            ] }),
            /* @__PURE__ */ l(
              Be,
              {
                value: e.form.messageTemplate,
                onChange: (m) => e.updateField("messageTemplate", m),
                readOnly: e.isReadOnly,
                height: "350px"
              }
            ),
            e.templateError && /* @__PURE__ */ l("small", { className: "text-[var(--clique-destructive)] text-xs", children: e.templateError })
          ] }),
          /* @__PURE__ */ l(je, { header: "Expansion Variables", toggleable: !0, collapsed: !0, className: "mt-2", children: /* @__PURE__ */ l(_e, { categoryLabel: e.categoryLabel }) }),
          e.submitError && /* @__PURE__ */ c("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
            /* @__PURE__ */ l("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
            e.submitError
          ] })
        ] }),
        /* @__PURE__ */ l(
          me,
          {
            visible: e.showPreview,
            onHide: () => e.setShowPreview(!1),
            html: e.previewHtml
          }
        )
      ]
    }
  );
}
function Ue(a) {
  const { categoryLabel: t = se, value: r, onChange: n, onError: s } = a, { numericTenantId: i } = D(), { data: d, isLoading: e } = ne(t), [y, o] = h(!1), [w, m] = h(void 0), [u, x] = h(!1), [T, j] = h(""), N = A({
    mutationFn: (g) => {
      if (i === null)
        throw new Error("Tenant ID is not resolved yet.");
      return L.getCompiled(i, g).then((B) => B.data);
    }
  }), O = U(
    () => (d ?? []).map((g) => ({ label: g.name, value: g.id })),
    [d]
  ), v = U(
    () => d == null ? void 0 : d.find((g) => g.id === r),
    [d, r]
  ), M = r != null && !e && d != null && v === void 0, P = b(
    (g) => {
      n(g);
    },
    [n]
  ), R = b(() => {
    o(!1), m(void 0);
  }, []), $ = b(
    (g) => {
      n(g.id);
    },
    [n]
  ), K = b(() => {
    r != null && N.mutate(r, {
      onSuccess: (g) => {
        j(g.rawTemplate), x(!0);
      },
      onError: (g) => {
        console.error("Failed to load email template preview", g), s == null || s("Failed to generate preview. Please try again.");
      }
    });
  }, [r, N, s]);
  return {
    categoryLabel: t,
    templates: d,
    dropdownOptions: O,
    isLoadingOptions: e,
    selectedTemplate: v,
    selectedTemplateMissing: M,
    handleSelect: P,
    showCreateDialog: y,
    setShowCreateDialog: o,
    editTemplateId: w,
    setEditTemplateId: m,
    handleDialogHide: R,
    handleTemplateSaved: $,
    showPreview: u,
    setShowPreview: x,
    previewHtml: T,
    handlePreview: K,
    isPreviewPending: N.isPending,
    canPreview: r != null
  };
}
function dt({
  value: a,
  onChange: t,
  categoryLabel: r,
  disabled: n = !1
}) {
  const s = Y(null), i = Ue({
    value: a,
    onChange: t,
    categoryLabel: r,
    onError: (d) => {
      var e;
      (e = s.current) == null || e.show({ severity: "error", summary: "Error", detail: d, life: 5e3 });
    }
  });
  return /* @__PURE__ */ c("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ l(le, { ref: s }),
    /* @__PURE__ */ c("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ l(
        Me,
        {
          value: i.selectedTemplateMissing ? null : a,
          options: i.dropdownOptions,
          onChange: (d) => i.handleSelect(d.value ?? null),
          placeholder: i.selectedTemplateMissing ? "Selected template unavailable" : "Use default template",
          loading: i.isLoadingOptions,
          disabled: n,
          showClear: !0,
          className: `w-64 ${i.selectedTemplateMissing ? "p-invalid" : ""}`
        }
      ),
      i.selectedTemplateMissing && /* @__PURE__ */ c("small", { className: "text-[var(--clique-warning-strong)] text-xs", children: [
        /* @__PURE__ */ l("i", { "aria-hidden": "true", className: "pi pi-exclamation-triangle mr-1" }),
        "The assigned template is no longer available. Pick another or clear to use the default."
      ] })
    ] }),
    /* @__PURE__ */ l(
      C,
      {
        type: "button",
        icon: "pi pi-plus",
        severity: "secondary",
        text: !0,
        rounded: !0,
        tooltip: "Create template",
        tooltipOptions: { position: "top" },
        disabled: n,
        onClick: () => i.setShowCreateDialog(!0)
      }
    ),
    /* @__PURE__ */ l(
      C,
      {
        type: "button",
        icon: "pi pi-pencil",
        severity: "secondary",
        text: !0,
        rounded: !0,
        tooltip: "Edit template",
        tooltipOptions: { position: "top" },
        disabled: n || a == null,
        onClick: () => i.setEditTemplateId(a ?? void 0)
      }
    ),
    /* @__PURE__ */ l(
      C,
      {
        type: "button",
        icon: "pi pi-eye",
        severity: "secondary",
        text: !0,
        rounded: !0,
        tooltip: "Preview template",
        tooltipOptions: { position: "top" },
        disabled: n || !i.canPreview,
        loading: i.isPreviewPending,
        onClick: i.handlePreview
      }
    ),
    /* @__PURE__ */ l(
      Qe,
      {
        visible: i.showCreateDialog || i.editTemplateId != null,
        onHide: i.handleDialogHide,
        templateId: i.editTemplateId,
        categoryLabel: i.categoryLabel,
        onSaved: i.handleTemplateSaved
      }
    ),
    /* @__PURE__ */ l(
      me,
      {
        visible: i.showPreview,
        onHide: () => i.setShowPreview(!1),
        html: i.previewHtml
      }
    )
  ] });
}
export {
  Qe as EmailTemplateDialog,
  ot as EmailTemplateList,
  me as EmailTemplatePreviewDialog,
  dt as EmailTemplateSelector,
  _e as EmailTemplateVariables,
  Be as HtmlCodeEditor,
  se as INVITATION_EMAIL_CATEGORY,
  S as emailTemplateKeys,
  L as emailTemplatesApi,
  ke as useCreateEmailTemplate,
  He as useDeleteEmailTemplate,
  Re as useEmailTemplate,
  Ve as useEmailTemplateDialogController,
  Ke as useEmailTemplateListController,
  Ue as useEmailTemplateSelectorController,
  $e as useEmailTemplateVariables,
  ne as useEmailTemplates,
  Ae as useUpdateEmailTemplate
};
//# sourceMappingURL=index.js.map
